import React from 'react'
import SidebarNew from '../../components/sidebar/SidebarNew';
import ActiveUsers from '../../components/user/ActiveUsers';

function ActiveUsersPage() {
  return (
    <div className="flex flex-col">
      <div className="flex flex-col">
        <div className="flex">
          <div className="h-full z-10 overflow-y-auto">
            <SidebarNew />
          </div>
          <div className="lg:flex-1 overflow-auto scrollbar-hide h-screen w-full md:z-10 p-4 lg:p-10 md:p-10">
            <ActiveUsers />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ActiveUsersPage